import axiosInstance from "utils/axios";

/**
 * Generic document download service.
 * @param {number} key - 1=IncidentReport, 2=ToolboxTalk, 3=VehicleDocument, 4=VehicleChecklist, 5=CompanyDocuments
 * @param {string} documentId - GUID of the document
 * @param {string} defaultFileName - Fallback file name
 */
export const downloadDocument = async (key, documentId, defaultFileName = "document") => {
  try {
    const url = `/api/Documents/Download?key=${key}&documentId=${documentId}`;
    const response = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const contentDisposition = response.headers?.["content-disposition"];
    let fileName = defaultFileName;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) fileName = match[1];
    }

    const blob = new Blob([response.data]);
    const href = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(href);

    return { success: true };
  } catch (error) {
    console.error("Error downloading document:", error);
    return { success: false, error: error.message || "Failed to download document" };
  }
};
